import React, {useEffect, useState} from 'react';
import { queueService } from '../services';
import { useSelector } from 'react-redux';
import { getAllCampaigns } from "../store/slices/campaignSlice";
import { Card, CardContent, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import { getAllUsers } from '../store/slices/pipedriveUserSlice';
import { InstyleButton } from '../components/Page/Page';
import Autocomplete from '@material-ui/lab/Autocomplete';


export const CampaignUserPath = "/campaign/users";

function CampaignUsers(props) {
    const theme = useTheme();
    const classes = useStyles(theme);
    let campaigns = useSelector(getAllCampaigns);
    let pipedriveUsers = useSelector(getAllUsers);
    const [selectedID, setSelectedID] = React.useState(0)
    const [campaignUsers, setCampaignUsers] = React.useState([]);

    useEffect(() => {
        queueService.getCampaignUsers().then(resp => {
            setCampaignUsers(resp.Data)
        })
    }, [])

    const selectCampaign = (id) => {
        if (selectedID === id) {
            setSelectedID(0);
            return;
        }
        setSelectedID(id);
    }

    const handleAutocompleteChange = (campaignID, e, val) => {
        //loop over the array of label, get the ids, put them in an array
        //set the value
        let v = val.map(i => {
            return {CampaignID: campaignID, UserID: parseInt(i.value)}
        })
        setCampaignUsers(v)
    }

    const saveCampaign = (id) => {
        //filter out the data for this campaign and send it to the server
        let saveData = campaignUsers.filter(cu => {
            return cu.CampaignID === id;
        })
        if (saveData.length > 0) {
            queueService.saveCampaignUsers(saveData).then(resp => {
                console.log('save sent')
            })
        } else {
            setSelectedID(0)
        }
    }

    const formatPipedriveUsers = () => {
        return Object.keys(pipedriveUsers).map((k) => {
            return {label: k, value: pipedriveUsers[k]}
        })
    }

    const getDefaultValues = () => {
        let defaults = [];
        //convert the pipedriveUsers object to an array
        let pdUsers = formatPipedriveUsers();
        campaignUsers.forEach(cu => {
            if (cu.CampaignID !== selectedID) {
                return false;
            }
            //find the matching pipedriveUser
            let foundUser = pdUsers.find(pu => {
                return pu.value === cu.UserID
            })
            defaults.push(foundUser)

        })
        return defaults;
    }

    return (
        <Grid container style={{overflow: "scroll", height: "100%", width: "100%", position: "relative", overflow: "scroll"}}>
            <Grid item xs={12} style={{textAlign: "center"}}>
                <h1 style={{fontFamily: "Ink", marginTop: ".2em"}}>Assign/Unassign Users</h1>
            </Grid>
            <Grid item xs={12}>
                {/* list all the campaigns
                when selecting a campaign be presented with a multi select to add/remove users to the campaign
                auto update to the database on changes? */}
                {
                    campaigns.map(c => {
                        const isSelected = c.ID === selectedID;
                        //get a list of id's of people that are selected here
                        const areSelected = (campaignUsers.filter(cu => {
                            return cu.CampaignID === c.ID;
                        })).map(res => {
                            return res.UserID;
                        })
                        return (
                            <div className={classes.campaignRoot}>
                                <Card className={clsx(classes.campaignCard, {
                                    [classes.campaignCardSelected]: isSelected,
                                })}
                                onClick={() => selectCampaign(c.ID)}>
                                    <CardContent>
                                        {c.Name}
                                    </CardContent>
                                </Card>
                                <FormControl className={clsx(classes.selectHidden, {
                                    [classes.selectShow]: isSelected,
                                    [classes.selectWidthWide]: isSelected,
                                })}>
                                    <Autocomplete
                                        multiple
                                        style={{width: "100%"}}
                                        options={formatPipedriveUsers()}
                                        onChange={(e, val) => handleAutocompleteChange(c.ID, e, val)}
                                        getOptionLabel={(option) => option.label}
                                        getOptionSelected={(options, value) => {
                                            return options.label === value.label
                                        }}
                                        value={getDefaultValues()}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            label="Pipedrive Users"
                                            placeholder="Select"
                                        />
                                        )}
                                    />
                                </FormControl>
                                <InstyleButton className={clsx(classes.selectHidden, {
                                    [classes.selectShow]: isSelected,
                                })} onClick={() => saveCampaign(c.ID)}>Save</InstyleButton>
                            </div>
                        )
                    })
                }
            </Grid>
        </Grid>
    )
}

export default CampaignUsers;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  campaignCard: {
    width: "100%",
    display: "inline-block",
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  campaignCardSelected: {
    width: `33%`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  selectHidden: {
      display: "none",
  },
  selectShow: {
      display: "inline-block",
  },
  selectWidthWide: {
      width: "80%",
      marginLeft: "25px",
      marginRight: "25px"
  },
  campaignRoot: {
    display: "flex",
    justifyContent: "space-evenly",
    alignContent: "stretch",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center"
  }
}));